import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import I10n from '../features/i10n';
import MsxIcons from '../features/msx-icons';
import Button from '../atoms/button';
import { PRIMARY_COLOR } from '../color-constants';

const Container = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  right: 0px;
  top: 200px;

  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  transition: transform 250ms;
  transform: translateX(calc(100% - 36px));
  cursor: pointer;
  background-color: ${PRIMARY_COLOR};
  background-color: var(--se-secondary, ${PRIMARY_COLOR});
  color: white;
  color: var(--se-secondary-contrast, white);
  ${props => props.forceShowing && `transform: none;`}

  :hover {
    transform: none;
  }

  ${props => props.fullScreenEnabled && `
    position: fixed;
    bottom: calc(50% + 50px);
    z-index: 200;
    top: unset;
  `}

  @media (max-width: 800px) {
    position: fixed;
    bottom: calc(50% + 50px);
    z-index: 200;
    top: unset;
  }

  @media (min-width: 800px) {
    ${props => props.showDisclaimer && `
      z-index: 376;
      transform: none;
  `}
  }
`;

const ButtonElements = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 10px 5px 5px;
`;

const Label = styled.span``;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  transform: scale(1.2);
`;

const DisclaimerWrapper = styled.div`
  position: fixed;
  z-index: 375;
  top: 0px;right: 0px;bottom:0px;left:0px;
  background-color: rgba(51,51,51, 0.5);
  @media (max-width: 800px) {
    display: none;
  }
`;

const DisclaimerModal = styled.div`
  position: absolute;
  background-color: #fefefe;
  width: 220px;
  border: 1px solid #888;
  border-radius: 4px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
  z-index: 376;
  transform: translateX(calc(-100% - 15px)) translateY(calc(50% - 25px));

  @media (max-width: 800px) {
    display: none;
  }
`;

const Heading = styled.div`
  font-weight: 400;
  font-size: 18px;
  text-align: center;
  margin-bottom: 10px;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
`;

const Content = styled.div`
  background-color: #fff;
  border-radius: 4px;
  padding: 15px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  color: #626469;
`;

const Arrow = styled.div`
  position: absolute;
  right: -9px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid white;
`;

const DisclaimerBody = styled.span`
  margin-bottom: 10px;
  display: block;
`;

class AddToMyProductButton extends React.Component {

  static propTypes = {
    distributorAddToMyProductLabel: PropTypes.string,
    seamlessSession: PropTypes.object,
    launchFromWorkspace: PropTypes.bool,
    isWorkspaceAvailable: PropTypes.bool,
    unifiedCheckoutAvailable: PropTypes.bool,
    disabled: PropTypes.bool,
    callback: PropTypes.func,
    fullScreenEnabled: PropTypes.bool,
    expandOnStart: PropTypes.bool
  }

  shouldShowDisclaimer = () => {
    let disclaimerExpired = true;

    try {
      const lastDisclaimerConfirmed = localStorage.getItem('plc_disclaimer_days');

      if (lastDisclaimerConfirmed) {

        const date = new Date();
        date.setDate(date.getDate() - 30);

        if (date.getTime() < Number(lastDisclaimerConfirmed)) {
          disclaimerExpired = false;
        }
      }
    } catch(error) {}

    return (!this.props.unifiedCheckoutAvailable && this.props.isWorkspaceAvailable) && disclaimerExpired;
  }

  constructor(props) {
    super(props);
    this.state = {
      forceShowing: (this.props.expandOnStart != null ? this.props.expandOnStart : false),
      showDisclaimer: this.shouldShowDisclaimer()
    }
    this._isMounted = false;
  }


  componentDidMount = () => {
    this._isMounted = true;
    if (this.props.expandOnStart) {
      setTimeout(() => {
        if (this._isMounted) {
          this.setState({forceShowing: false});
        }
      }, 3000);
    }
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  render = () => {
    let buttonText = I10n.get('saved_configuration.export.my_product');
    let buttonIcon = 'favorites';

    if (this.props.launchFromWorkspace) {
      buttonText = this.props.distributorAddToMyProductLabel ? this.props.distributorAddToMyProductLabel : I10n.get('saved_configuration.export.my_project');
      buttonIcon = 'new-project';
    } else if (this.props.unifiedCheckoutAvailable) {
      buttonText = I10n.get('saved_configuration.export.add_to_my_cart');
      buttonIcon = 'ecommerce';
    } else if (this.props.isWorkspaceAvailable) {
      buttonText = I10n.get('saved_configuration.export.save_and_add_to_my_project');
      buttonIcon = 'new-project';
    } else if (window.top !== window.self) {
      buttonText = this.props.distributorAddToMyProductLabel ? this.props.distributorAddToMyProductLabel : I10n.get('saved_configuration.export.add_cart');
      buttonIcon = 'ecommerce';
    }

    return (
      <>
        <Container showDisclaimer={this.state.showDisclaimer} forceShowing={this.state.forceShowing} fullScreenEnabled={this.props.fullScreenEnabled} disabled={this.props.disabled}>
          <ButtonElements onClick={() => { if (!this.props.disabled && !this.state.showDisclaimer && this.props.callback) { this.props.callback(); } }}>
            <IconWrapper><MsxIcons name={buttonIcon}></MsxIcons></IconWrapper>
            <Label>{buttonText}</Label>
          </ButtonElements>
          {this.state.showDisclaimer && <DisclaimerModal>
            <Content>
              <Arrow />
              <Heading>{I10n.get('saved_configuration.export.save_and_add_to_your_project')}</Heading>
              <DisclaimerBody>{I10n.get('disclaimer.content')}</DisclaimerBody>
              <Button primary onClick={() => { this.setState({showDisclaimer: false}); try {localStorage.setItem('plc_disclaimer_days', new Date().getTime().toString())} catch(e){} }}>
                {I10n.get('app.action.i_understand')}
              </Button>
            </Content>
          </DisclaimerModal>}
        </Container>
        {this.state.showDisclaimer && <DisclaimerWrapper></DisclaimerWrapper>}
      </>
    );
  }
}

export default AddToMyProductButton;
